class NavManagerSingleton {
	subscriptions = [];

	showNavigation = () => {
		for (const subscription of this.subscriptions) {
			subscription(true);
		}
	};

	hideNavigation = () => {
		for (const subscription of this.subscriptions) {
			subscription(false);
		}
	};

	subscribe = callback => {
		this.subscriptions.push(callback);
	};

	unsubscribe = callback => {
		this.subscriptions = this.subscriptions.filter(subscription => subscription !== callback);
	};
}

// When provided a Gatsby Node ID, e.g.
// "/Users/kevin/development/inside-out/frontend/content/resource-library/testing-resources.json absPath of file >>> JSON"
// Strips out anything before the content folder in the path, then slices out from .json onwards to give us just the absolute
// link to a page that'll be dynamically created in gatsby-node.js
export const idToLink = id => id.replace(/^.+\/content\//, '/').replace(/\.json.+$/, '');

export const NavManager = new NavManagerSingleton();



// WEBPACK FOOTER //
// ./src/managers/navManager.js